import api from "api";
import { ResponseTransform } from "utils";

export const getPermissionsList = async (id) => {
  let responseApi = await api
    .get(`api/rol/get-view-rol/${id}`)
    .then(ResponseTransform);
  return responseApi;
};
